import { createFileRoute, redirect } from "@tanstack/react-router";

// Consolidated into the ONE "What is SAINT?" guide at /learn/what-is-saint-tms.
// Edge 301 is mirrored in public/_redirects.
export const Route = createFileRoute("/saint-tms-5-day-depression-treatment")({
  beforeLoad: () => {
    throw redirect({ to: "/learn/what-is-saint-tms", statusCode: 301 });
  },
});
